import { Injectable } from '@angular/core';

@Injectable()
export class DataTableService{
  istance: IDataTableService[] = [];

  get(id){
    var istance = this.istance.find(el => el.id == id);
    if(!istance){
      istance = <IDataTableService>{ id: id };

      this.istance.push(istance);
    }
    return istance;
  }
}

class IDataTableService{
  id: string;
  showDetail?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/dataTable/dataTable.service.ts